import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext';
import Cargando from 'components/Varios/Cargando';
import YearDatePicker from 'components/Varios/DatePicker/YearDatePicker';
import React, { useMemo, useState } from 'react'
import { Card, CardBody, CardTitle, CardFooter, Row, Col, Button } from "reactstrap"
import { DetalleRegimenLaboralHEDTO, unidadesEspeciales } from './TypesPlanificacionHE';
import NumberFormat from 'react-number-format';

type PropsCardRegimenHE = {
    regimenLaboralPlan: DetalleRegimenLaboralHEDTO;
    index: number;
    tipo: "SOLICITUD" | "PLANIFICACION"
    idunidad?:number
}



export default function CardRegimenHE(props: PropsCardRegimenHE) {

    let TITULO_CARD = props.regimenLaboralPlan.siglasRegimenLaboral;

    const { regimenLaboralPlan, idunidad } = props

    const color = getColor(props.index);  // Función para obtener el color basado en el índice

    // Función para seleccionar un color
    function getColor(index: number) {
        const colors = ['#243561', '#57b631', '#FF7E01'];
        return colors[index % colors.length];  // Usa el módulo para rotar a través de los colores
    }

    var valorDisponibleParaPlanificar: number = regimenLaboralPlan.presupuestoCodificado - regimenLaboralPlan.devengadoPagado ;
    if (regimenLaboralPlan.planificacionMesAnterior && regimenLaboralPlan.devengadoNoPagado > regimenLaboralPlan.planificacionMesAnterior) {
        valorDisponibleParaPlanificar -= regimenLaboralPlan.devengadoNoPagado;
    }
    else {
        if (regimenLaboralPlan.planificacionMesAnterior)
            valorDisponibleParaPlanificar -= regimenLaboralPlan.planificacionMesAnterior;
    }
    
    if (idunidad && unidadesEspeciales.includes(idunidad) ) {
        valorDisponibleParaPlanificar = regimenLaboralPlan.presupuestoCodificado - regimenLaboralPlan.devengadoPagado - regimenLaboralPlan.devengadoNoPagado;
    }

    return (
        <Card className="same-height-card">
            <CardTitle className="cardHeaderRegimenPlanificacion" style={{ backgroundColor: color }}  >
                {TITULO_CARD}

            </CardTitle>

            <CardBody>
                {regimenLaboralPlan.idRegimenLaboral === 999 && (
                    <>
                    <Row>
                            <Col xl={12}>
                                <div className='groupInfoRegimen'>
                                    <p className='labelInfoRegimenBlue'> PRESUPUESTO PROYECTADO: </p>
                                    <p className='valueInfoRegimenBlue'>
                                        <NumberFormat value={regimenLaboralPlan.presupuestoProyectado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                    </p>

                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={12}>
                                <div className='groupInfoRegimen'>
                                    <p className='labelInfoRegimenGray'> PRESUPUESTO ASIGNADO: </p>
                                    <p className='valueInfoRegimen'>
                                        <NumberFormat value={regimenLaboralPlan.presupuestoAsignado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                    </p>

                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={12}>
                                <div className='groupInfoRegimen'>
                                    <p className='labelInfoRegimenGray'> REFORMA PRESUPUESTARIA <span className='spanLabelInfoRegimen'>(MODIFICACIONES):</span></p>
                                    <p className='valueInfoRegimen'>
                                        <NumberFormat value={regimenLaboralPlan.reformaPresupuestaria} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={12}>
                                <div className='groupInfoRegimen'>
                                    <p className='labelInfoRegimenBlack'> PRESUPUESTO CODIFICADO:</p>
                                    <p className='valueInfoRegimen'>
                                        <NumberFormat value={regimenLaboralPlan.presupuestoCodificado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </>
                )}

                <Row style={{ marginBottom: props.regimenLaboralPlan.idRegimenLaboral === 999 ? '0px' : '20px', marginTop: props.regimenLaboralPlan.idRegimenLaboral === 999 ? '0px' : '20px' }}>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO DEVENGADO Y PAGADO:</p>
                            <p className='valueInfoRegimen'>
                                <NumberFormat value={regimenLaboralPlan.devengadoPagado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginBottom: props.regimenLaboralPlan.idRegimenLaboral === 999 ? '0px' : '20px' }}>
                    <Col xl={12}>
                        <div className='groupInfoRegimen'>
                            <p className='labelInfoRegimenGray'> PRESUPUESTO DEVENGADO Y NO PAGADO:</p>
                            <p className='valueInfoRegimen'>
                                <NumberFormat value={regimenLaboralPlan.devengadoNoPagado} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                            </p>
                        </div>
                    </Col>
                </Row>
                {
                    props.tipo === "PLANIFICACION" ?
                        <Row style={{ marginBottom: props.regimenLaboralPlan.idRegimenLaboral === 999 ? '0px' : '20px' }}>
                            <Col xl={12}>
                                <div className='groupInfoRegimen'>
                                    <p className='labelInfoRegimenGray'> PRESUPUESTO PLANIFICADO MES ACTUAL:    </p>
                                    <p className='valueInfoRegimen'>
                                        <NumberFormat value={regimenLaboralPlan.planificadoActual} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        :
                        <>
                            {
                                props.regimenLaboralPlan.idRegimenLaboral === 999 && (
                                    <Row>
                                        <Col xl={12}>
                                            <div className='groupInfoRegimen'>
                                                <p className='labelInfoRegimenBlack'> PRESUPUESTO POR DEVENGAR:</p>
                                                <p className='valueInfoRegimen'>
                                                    <NumberFormat value={regimenLaboralPlan.presupuestoDevengar} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                )
                            }
                        </>


                }
                {
                    props.tipo !== "PLANIFICACION" &&
                    <>
                        {
                            props.regimenLaboralPlan.idRegimenLaboral === 999 && (
                                <Row>
                                    <Col xl={12}>
                                        <div className='groupInfoRegimen'>
                                            <p className='labelInfoRegimenBlack'> PRESUPUESTO PLANIFICADO MES ANTERIOR:</p>
                                            <p className='valueInfoRegimen'>
                                                <NumberFormat value={regimenLaboralPlan.planificacionMesAnterior} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        }
                    </>

                }
                {
                    props.tipo !== "PLANIFICACION" &&
                    <>
                        {
                            props.regimenLaboralPlan.idRegimenLaboral === 999 && (
                                <Row>
                                    <Col xl={12}>
                                        <div className='groupInfoRegimen'>
                                            <p className='labelInfoRegimenBlack'> PRESUPUESTO DISPONIBLE PARA PLANIFICACIÓN:</p>
                                            <p className='valueInfoRegimen'>
                                                <NumberFormat value={valorDisponibleParaPlanificar} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        }
                    </>

                }
                {
                    props.tipo === "PLANIFICACION" ?
                        <>
                            {
                                props.regimenLaboralPlan.idRegimenLaboral === 999 && (
                                    <Row>
                                        <Col xl={12}>
                                            <div className='groupInfoRegimen'>
                                                <p className='labelInfoRegimenBlack'> PRESUPUESTO POR DEVENGAR:</p>
                                                <p className='valueInfoRegimen'>
                                                    <NumberFormat value={regimenLaboralPlan.presupuestoDevengar} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>
                                )
                            }
                        </>
                        :
                        <Row style={{ marginBottom: props.regimenLaboralPlan.idRegimenLaboral === 999 ? '0px' : '20px' }}>
                            <Col xl={12}>
                                <div className='groupInfoRegimen'>
                                    <p className='labelInfoRegimenGray'> PRESUPUESTO PLANIFICADO MES ACTUAL:    </p>
                                    <p className='valueInfoRegimen'>
                                        <NumberFormat value={regimenLaboralPlan.planificadoActual} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                    </p>
                                </div>
                            </Col>
                        </Row>
                }
                





            </CardBody>


        </Card>
    )


}